<template>
  <div class="container text-secondary">
    <div class="row mb-3">
      <div class="col-2"/>
      <div class="col">
        <div class="h4">🪑 Aan tafel</div>
      </div>
      <div class="col-2 text-end pe-2">
        <img src="@/assets/back-48.png" alt="terug" class="img-fluid"
             style="height:32px; cursor:pointer;" @click="$router.push('/')"/>
      </div>
    </div>

    <hr class="divider">

    <!-- Spelers aan tafel -->
    <div class="card-modern">
      <div style="font-weight:700; color:#4a5568; margin-bottom:12px;">
        Aan tafel
        <span style="font-size:0.85rem; color:#a0aec0; font-weight:400;">
          — sleep om volgorde te wijzigen
        </span>
      </div>

      <div v-if="tafel.length === 0" style="color:#a0aec0; text-align:center; padding:16px;">
        Nog niemand aan tafel
      </div>

      <draggable
          v-model="tafel"
          item-key="id"
          handle=".drag-handle"
          animation="150"
          @end="slaOp"
      >
        <template #item="{ element, index }">
          <div class="tafel-rij">
            <span class="drag-handle">☰</span>
            <span class="tafel-avatar">{{ element.gender === 'female' ? '👩' : '👨' }}</span>
            <span class="tafel-naam">{{ element.name }}</span>
            <span v-if="index === 0" class="dealer-badge">Eerste deler</span>
            <button class="verwijder-btn" @click="verwijderVanTafel(element.id)">✕</button>
          </div>
        </template>
      </draggable>
    </div>

    <!-- Beschikbare spelers -->
    <div class="card-modern">
      <div style="font-weight:700; color:#4a5568; margin-bottom:12px;">
        Toevoegen aan tafel
      </div>

      <div v-if="beschikbaar.length === 0" style="color:#a0aec0; text-align:center; padding:8px;">
        Alle spelers zitten aan tafel
      </div>

      <div v-for="player in beschikbaar" :key="player.id"
           class="beschikbaar-rij" @click="voegToe(player)">
        <span class="tafel-avatar">{{ player.gender === 'female' ? '👩' : '👨' }}</span>
        <span class="tafel-naam">{{ player.name }}</span>
        <span style="color:#667eea; font-size:1.2rem;">＋</span>
      </div>
    </div>

    <div v-if="tafel.length >= 2" class="text-center">
      <button class="btn-primary-modern" @click="$router.push('/')">
        Klaar
      </button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import store from "@/store";

export default {
  name: "PlayersRoom",
  components: { draggable },
  data() {
    return {
      tafel: [],
    };
  },
  computed: {
    players() {
      return store.state.players;
    },
    beschikbaar() {
      return this.players.filter(p => !this.tafel.find(t => t.id === p.id));
    },
  },
  created() {
    this.tafel = [...store.state.playersRoom];
  },
  methods: {
    voegToe(player) {
      this.tafel.push(player);
      this.slaOp();
    },
    verwijderVanTafel(id) {
      this.tafel = this.tafel.filter(p => p.id !== id);
      this.slaOp();
    },
    slaOp() {
      store.commit('setPlayersRoom', [...this.tafel]);
    },
  },
}
</script>

<style scoped>
.tafel-rij {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  border-radius: 10px;
  margin-bottom: 6px;
  background: #f7fafc;
  border: 2px solid transparent;
  transition: all 0.15s;
  user-select: none;
}
.drag-handle {
  color: #cbd5e0;
  font-size: 1.1rem;
  cursor: grab;
  padding: 0 4px;
  touch-action: none;
}
.drag-handle:active { cursor: grabbing; }
.tafel-avatar { font-size: 1.3rem; }
.tafel-naam { flex: 1; font-weight: 600; color: #2d3748; }
.dealer-badge {
  font-size: 0.75rem;
  background: #667eea;
  color: white;
  border-radius: 8px;
  padding: 2px 8px;
  font-weight: 700;
}
.verwijder-btn {
  background: none;
  border: none;
  color: #fc8181;
  cursor: pointer;
  font-size: 1rem;
  padding: 4px 6px;
  border-radius: 6px;
}
.verwijder-btn:hover { background: #fff5f5; }
.beschikbaar-rij {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  border-radius: 10px;
  margin-bottom: 6px;
  background: #f7fafc;
  cursor: pointer;
  transition: all 0.15s;
}
.beschikbaar-rij:hover { background: #ebf4ff; }
</style>